





import { defineComponent } from '@vue/composition-api'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
export default defineComponent({
  props:{
    data: Object,
    depth: Number
  },
  components:{VueJsonPretty}
})
